setTimeout(() => {
  const $ = window.jQuery;
  const eta = 300;
  const el = 'power-reviewer';
  const validateEmail = (email) =>
		/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
  const setError = (name, validated = false) => {
    $(`.${el} [name="${name}"]`)[validated ? "removeClass" : "addClass"](
      "js-error"
    );
  };
  const validateFormRow = (name, value) => {
    let validated = true;
    if (name == "email" && !validateEmail(value)) {
      validated = false;
    } else if (String(value).trim() == '') {
      validated = false;
    }

    setError(name, validated);
    return validated;
  };
  const formSubmissionSuccess = () => {
    $(`.${el}__success`).slideDown(eta);
    $(`.${el}__inner`).slideUp(eta);
  };
  const formSubmissionError = () => {
    $(`.${el}__error`).slideDown(eta);
    $(`.${el}__inner`).slideUp(eta);
  };

  const submitForm = (formData) => {
    const product = String(
      formData.find((i) => i.name == "product")?.value
    ).split("|");

    const data = {
			appkey: formData.find((i) => i.name == "appkey")?.value,
			product_title: product[0],
			sku: product[1],
			product_url: product[2],
			domain: formData.find((i) => i.name == "domain")?.value,
			is_incentivized: true,
			display_name: formData.find((i) => i.name == "name")?.value,
			email: formData.find((i) => i.name == "email")?.value,
			review_content: formData.find((i) => i.name == "review")?.value,
			review_title: formData.find((i) => i.name == "review-title")?.value,
			review_score: formData.find((i) => i.name == "star-rating")?.value,
		};

    $.ajax({
      url: "https://api.yotpo.com/v1/widget/reviews",
      method: "POST",
      data: data,
      success: (r) => {
        if (r.code == 200) {
          formSubmissionSuccess();
        }
        else {
          formSubmissionError();
        }
      },
      error: () => formSubmissionError(),
    });
  };


  const onloadHash = window.location.hash.split("#")[1];

  if ($(`.${el} [name="product"] [data-handle="${onloadHash}"]`)) {
    $(`.${el} [name="product"]`).val(
      $(`.${el} [name="product"] [data-handle="${onloadHash}"]`).attr('value')
    );
  }

  $(`.${el} [type="submit"]`).click((e) => {
    e.preventDefault();
    const formData = $(`.${el} :input:not([type="submit"])`).serializeArray();
    const formValidated = formData.map((i) => {
      return validateFormRow(i.name, i.value);
    }).filter(i => !i).length == 0;
    if (formValidated) {
      submitForm(formData);
    }
  });

  $(`.${el} :input:not([type="submit"])`).blur((e) => {
		const formData = $(e.currentTarget).serializeArray().shift();
		validateFormRow(formData.name, formData.value);
	});
}, 5000);
